import React from "react";

const defaultPhrases = [
    "The alchemy of healing",
    "Where past experiences become the foundation for growth",
    "EMDR therapy for clarity, confidence, and meaningful change",
    "Trauma-focused care for high-functioning adults",
];

export default function Marquee({ phrases = defaultPhrases, background = "#8A9E85" }) {
    const items = [...phrases, ...phrases, ...phrases];
    return (
        <section
            data-testid="marquee-section"
            className="overflow-hidden text-ivory"
            style={{ background, borderTop: "1px solid #E2DDD8", borderBottom: "1px solid #E2DDD8" }}
        >
            <div className="relative py-7">
                <div className="flex whitespace-nowrap animate-marquee will-change-transform">
                    {items.map((p, i) => (
                        <span key={i} className="flex items-center font-serif text-2xl sm:text-3xl italic mr-12 text-ivory">
                            <span className="text-gold mr-12 not-italic font-sans">✦</span>
                            {p}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
